import { AirportTransferApiDto } from '@lx/shared/api/models';

export type Transfer = AirportTransferApiDto;
export type TransferServiceType = AirportTransferApiDto.TransferServiceTypeEnum;
export const TransferServiceTypeEnum = AirportTransferApiDto.TransferServiceTypeEnum;
export type TransferServiceDetail = AirportTransferApiDto.TransferServiceTypeDetailEnum;
export const TransferServiceDetailEnum = AirportTransferApiDto.TransferServiceTypeDetailEnum;
export const StationTypeEnum = AirportTransferApiDto.StationTypeEnum;
export const DropOffTypeEnum = AirportTransferApiDto.DropOffTypeEnum;
